export default __webpack_public_path__ + "3da11e3fc928bd532e70d5e6b9051f78.svg";